export default __webpack_public_path__ + "static/media/07_TheQueue.731adf96.jpg";